import UserModel from '../../../../UserModel';
import { CYCLE_DETAILS_ROUTE, CYCLE_WAVE_DETAILS_ROUTE } from '../../../modules/cycleCount/consts';
import { WAREHOUSES_DETAILS_PATH } from '../../../modules/warehouses/consts';
const hasAnyPermissions = (permissions) => UserModel.getCurrentUser().hasAnyPermissions(permissions);

export default {
    name: 'managerReviewPage',
    before: [],
    after: ['cycleCount'],
    setup: (app) => {
        app.routes.deleteItem('cycleCountManagerReviewGrid');

        const cycleCountMenuItem = app.sideMenuItems.getItem('cycleCount');
        app.sideMenuItems.changeItem('cycleCount', {
            ...cycleCountMenuItem,
            items: (cycleCountMenuItem?.items || []).filter((item) => item.label !== 'Manager Review'),
        });
    },
};
